import React from "react";
import { useUserContext } from "context/UserContext";
import DeviceInfoBK from "layouts/BK/deviceInfo";
import DeviceInfoSP from "layouts/SP/deviceInfo";
import DeviceInfoCM from "layouts/CM/deviceInfo";
import { isBkLikeRole } from "utils/roleUtils";

function BatteryInfos() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <DeviceInfoSP />;
  }
  if (isBkLikeRole(role)) {
    return <DeviceInfoBK />;
  }
  if (role === "CM") {
    return <DeviceInfoCM />;
  }
  return null;
}

export default BatteryInfos;
